import * as React from "react";
import {App} from "./App";
import ReactDOM = require("react-dom");
import 'shared/styles/bootstrap.scss';

export class Bootstrap extends React.Component<BootstrapProps, BootstrapState> {
    static defaultProps: Partial<BootstrapProps> = {};

    constructor(props: BootstrapProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <App></App>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface BootstrapProps {

}

interface BootstrapState {

}

ReactDOM.render(<Bootstrap/>,document.getElementById('AppRot'));